var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#5d3cc7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 9a3 3 0 1 1 6 0 3 3 0 1 1-6 0Zm3-1.5c.825 0 1.5.675 1.5 1.5s-.675 1.5-1.5 1.5-1.5-.675-1.5-1.5.675-1.5 1.5-1.5ZM12 13.5c-2.002 0-6 1.005-6 3V18h12v-1.5c0-1.995-3.998-3-6-3Zm0 1.5c2.025 0 4.35.967 4.5 1.5h-9c.173-.54 2.482-1.5 4.5-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.778 2H4.222C3 2 2 3 2 4.222v15.556C2 21 3 22 4.222 22h15.556C21 22 22 21 22 19.778V4.222C22 3 21 2 19.778 2ZM20 4v16H4V4h16Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonIcon);
export default __webpack_public_path__ + "static/media/person_icon.93a9622e62e11fc06c3e866ec52da9ec.svg";
export { ForwardRef as ReactComponent };